<template>
  <div class="wizard-body small-9 columns">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.DESC')"
    />
    <div class="margin-top-3" v-if="selectedProvider === null">
      <h4 class="font-bold">{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.TITLE') }}</h4>
      <p>{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.DESC') }}</p>
      <div class="provider-cards-container">
        <div class="provider-card" @click="selectProvider('360_cloud')">
          <img src="/assets/images/whatsapp_inbox/360dialog.png" alt="360Dialog logo" />
          <h5 class="font-bold">{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.DIALOG.NAME') }}</h5>
          <p>{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.DIALOG.DESC') }}</p>
        </div>
          <div
            v-tooltip.top="!hasWhatsappAppId ? $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META.UNAVAILABLE_TOOLTIP') : false"
            :class="{'provider-card': true, 'inactive': !hasWhatsappAppId}"
            @click="hasWhatsappAppId && selectProvider('whatsapp_embedded_signup')"
          >
            <img src="/assets/images/whatsapp_inbox/meta_logo.svg" alt="Meta logo" />
            <h5 class="font-bold">{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META.NAME') }}</h5>
            <p>{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META.DESC') }}</p>
          </div>
      </div>
      <div class="meta-requirements-box">
        <p class="font-bold margin-bottom-2">{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META_REQUIREMENTS.TITLE') }}</p>
        <p class="font-bold">{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META_REQUIREMENTS.ACCESS_TITLE') }}</p>
        <ul>
          <li>{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META_REQUIREMENTS.ACCESS_ITEM_1') }}</li>
          <li>{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META_REQUIREMENTS.ACCESS_ITEM_2') }}</li>
          <ul> 
            <li>{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META_REQUIREMENTS.ACCESS_OBS') }}</li>
          </ul>
        </ul>
        <p class="font-bold">{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META_REQUIREMENTS.PHONE_TITLE') }}</p>
        <ul>
          <li>{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META_REQUIREMENTS.PHONE_ITEM_1') }}</li>
          <li>{{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDER_SELECTION.META_REQUIREMENTS.PHONE_ITEM_2') }}</li>
        </ul>
      </div>
    </div>
    <div v-else>
      <a class="back-link" @click="selectedProvider = null">{{ $t('INBOX_MGMT.ADD.WHATSAPP.BACK_BUTTON') }}</a>
      <three-sixty-dialog-cloud-whatsapp
        v-if="selectedProvider === '360_cloud'"
      />
      <whatsapp-embedded-signup
        v-else-if="selectedProvider === 'whatsapp_embedded_signup'"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from '../../SettingsSubPageHeader';
import ThreeSixtyDialogCloudWhatsapp from './360DialogCloudWhatsapp';
import WhatsappEmbeddedSignup from './WhatsappEmbeddedSignup';

export default {
  components: {
    PageHeader,
    ThreeSixtyDialogCloudWhatsapp,
    WhatsappEmbeddedSignup,
  },
  data() {
    return {
      selectedProvider: null,
    };
  },
  computed: {
    hasWhatsappAppId() {
      return (
        window.chatwootConfig?.whatsappAppId &&
        window.chatwootConfig.whatsappAppId !== 'none'
      );
    },
  },
  methods: {
    selectProvider(provider) {
      this.selectedProvider = provider;
    },
  },
};
</script>

<style scoped>
.wizard-body {
  height: auto;
  border: 1px solid var(--s-50);
  padding: 2.4rem;
  background: #fff;
}
.provider-cards-container {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  height: 333px;
  width: 100%;
}
.provider-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 2rem 1.5rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  transition: box-shadow 0.2s;
  gap: 1rem;
  flex: 1;
}
.provider-card:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
}
.provider-card img {
  width: 154px;
  height: 154px;
  margin-bottom: 1rem;
}
.inactive {
  filter: grayscale(100%);
  color: #999;
  background: #f1f1f1;
  cursor: not-allowed;
}
.inactive:hover {
  box-shadow: none;
}
.meta-requirements-box {
  background: #F6F4FE;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 2rem;
  font-size: 0.98rem;
}
.meta-requirements-box ul {
  margin: 0 0 1rem 1.5rem;
}
.back-link {
  display: inline-block;
  margin-bottom: 1.5rem;
  color: #2563eb;
  cursor: pointer;
  font-weight: 500;
}
</style>
